import React from 'react';
import { FadeIn, CTAButton, Section, SectionTitle, Accent, Stars } from './Shared';
import { ProductVideo } from './ProductVideo';
import { featuredTestimonials } from '../data/testimonials';
import { ShieldCheck, Lock, Globe2, Star, X, ArrowRightIcon, FileTextIcon, ZapIcon, LayersIcon, TrophyIcon } from 'lucide-react';
export const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/a5wDcjcYkyBHi6BisQcSi3/MOCKUP_PNG.png';
const PRODUCT_VIDEO = 'https://cdn.magicpatterns.com/uploads/v8gnCg5mXtVLgwG8WBwDon/Libros%20FUNCIONAL.mp4';
export const Hero = () => {
  const chips = [{
    icon: FileTextIcon,
    label: '100% PDF'
  }, {
    icon: ZapIcon,
    label: 'Acceso en 5 min'
  }, {
    icon: LayersIcon,
    label: '365 sesiones'
  }];
  return <section className="relative overflow-hidden border-b border-white/5 bg-slate-950" data-id="element-284" data-mp="dyhhakwqgu3w">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-sky-400/40" aria-hidden="true" data-id="element-285" data-mp="1kj0hkb8rgafk" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-[minmax(0,1fr)] items-center justify-items-center gap-3 px-5 pb-10 pt-4 sm:gap-6 sm:pt-8 md:px-8 md:pb-20 md:pt-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:justify-items-stretch lg:gap-x-12 lg:gap-y-8" data-id="element-286" data-mp="1phtxsbffmfjf">
        {/* Headline */}
        <FadeIn className="flex w-full min-w-0 flex-col items-center text-center lg:col-start-1 lg:row-start-1 lg:items-start lg:self-end lg:text-left" data-id="element-287" data-mp="18bgsg9jfwt63">
          <p className="mb-2 flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-sky-400 sm:mb-4 sm:text-xs" data-id="element-288" data-mp="ychqtax3dxsl">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-sky-400" aria-hidden="true" data-id="element-289" data-mp="olmvzi5s5pvj" />
            MEGAPACK FUNCIONAL 365™
          </p>
          <h1 className="w-full break-words pr-[0.06em] font-display text-[clamp(28px,8.6vw,40px)] font-black uppercase italic leading-[1] tracking-tight text-white sm:text-5xl md:text-6xl lg:pr-0 lg:text-[64px]" data-id="element-290" data-mp="klcpm4e2sxg5">
            Organiza todas tus clases de <Accent data-id="element-291" data-mp="ao81w04l0tx8">funcional.</Accent>
            <span className="mt-1 block text-slate-400" data-id="element-292" data-mp="y011mf5odi6">En 5 minutos.</span>
          </h1>
          <p className="mx-auto mt-2.5 max-w-[340px] text-[13.5px] leading-snug text-slate-300 sm:mt-5 sm:max-w-md sm:text-base sm:leading-relaxed md:text-lg lg:mx-0" data-id="element-293" data-mp="5xvxn0lix2np">
            Tu sistema completo de entrenamiento funcional: 365 días de sesiones,
            calentamientos, circuitos, progresiones y planificación lista para aplicar.
          </p>
        </FadeIn>

        {/* Mockup */}
        <FadeIn delay={0.05} className="flex w-full min-w-0 justify-center lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-294" data-mp="onkke6f81crz">
          <a href="#pricing" className="group block w-full" aria-label="Ver la oferta" data-id="element-295" data-mp="9xwltcyfcs7y">
            <img src={HERO_MOCKUP} alt="MEGAPACK Funcional 365 — los 6 tomos, el pack de bonos y el acceso digital en tablet, computadora y celular" width={1536} height={1024} loading="eager" decoding="async"
          // @ts-ignore fetchpriority is valid HTML
          fetchpriority="high" className="mx-auto block h-auto w-full max-w-[380px] object-contain transition-transform duration-200 ease-out group-hover:-translate-y-1 sm:max-w-[560px] lg:max-w-none" data-id="element-296" data-mp="ex97hudk7t8y" />
          </a>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.1} className="flex w-full min-w-0 max-w-[420px] flex-col items-center sm:max-w-none lg:col-start-1 lg:row-start-2 lg:items-start lg:self-start" data-id="element-297" data-mp="2wvz7k7hth4l7">
          <ul className="mb-3 flex w-full flex-wrap items-center justify-center gap-1.5 sm:mb-5 sm:gap-2 lg:justify-start" data-id="element-298" data-mp="247lbhxaagica">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-[11px] font-medium text-slate-200 sm:gap-1.5 sm:px-3 sm:py-1.5 sm:text-xs md:text-sm" data-id="element-299" data-mp="2e57q0inoe7vq">
                <Icon size={14} className="text-sky-400" aria-hidden="true" data-id="element-300" data-mp="oox4biplnio5" />
                {label}
              </li>)}
          </ul>
          <CTAButton href="#pricing" className="w-full sm:w-auto" data-id="element-301" data-mp="sra7bzcyp2h8">
            Quiero el MEGAPACK ahora
            <ArrowRightIcon size={18} className="transition-transform duration-200 group-hover/cta:translate-x-0.5" aria-hidden="true" data-id="element-302" data-mp="xo0m8jd15s12" />
          </CTAButton>
          <div className="mt-3 flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center text-[11px] text-slate-400 sm:mt-4 sm:gap-x-4 sm:text-xs lg:justify-start" data-id="element-303" data-mp="17ob0m7asx5ht">
            <span className="flex items-center gap-1.5" data-id="element-304" data-mp="1gg39idk6g6ka">
              <ShieldCheck size={14} className="text-emerald-400" aria-hidden="true" data-id="element-305" data-mp="1ggmp3nmcuiv5" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-306" data-mp="1lhahacmbl5qy">
              <Lock size={14} aria-hidden="true" data-id="element-307" data-mp="1qfbzywfu331w" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-308" data-mp="1vckgytp8x11k">
              <Globe2 size={14} className="text-sky-400" aria-hidden="true" data-id="element-309" data-mp="1vb9a2l0i7d68" /> Pagas en tu moneda local
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'coaches confían'
  }, {
    value: '6',
    label: 'Tomos Completos'
  }, {
    value: '5',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="border-b border-white/5 bg-slate-900/40 px-5 py-8 md:px-8" data-id="element-310" data-mp="2fgiprhoix6u">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-6 md:grid-cols-4" data-id="element-311" data-mp="3tm9jwvch2wbd">
        {stats.map((s, i) => <div key={s.label} className={`text-center ${i % 2 === 1 ? 'border-l border-white/10' : ''} ${i > 0 ? 'md:border-l md:border-white/10' : ''}`} data-id="element-312" data-mp="3ovb3zwvec08n" data-mpi={i}>
            <dt className="sr-only" data-id="element-313" data-mp="l79cho4komfm">{s.label}</dt>
            <dd className="font-display text-4xl font-black italic leading-none tracking-tight text-white md:text-5xl" data-id="element-314" data-mp="l92kp7uu3epq">
              {s.value}
            </dd>
            <dd className="mt-2 flex items-center justify-center gap-1 text-sm text-slate-400" data-id="element-315" data-mp="2ap67pmu5tmoj">
              {s.label}
              {s.star && <Star size={12} className="fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-316" data-mp="2fmepvnfb5qps" />}
            </dd>
          </div>)}
      </dl>
    </div>;
};
export const Testimonials1 = () => <Section className="bg-slate-950 !py-12 md:!py-16" data-id="element-317" data-mp="25vk6cqtg5581">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-318" data-mp="1rx3wws4790m7">
      {featuredTestimonials.map((t, i) => <FadeIn key={t.author} delay={Math.min(i * 0.05, 0.15)} data-id="element-319" data-mp="1vzh2ngiy4yiz" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6" data-id="element-320" data-mp="1hzft7com8irw">
            <Stars data-id="element-321" data-mp="1my0t1azyh0ft" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-322" data-mp="1mzlor3y0apf9">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-323" data-mp="3cea33aq5qhfx">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-324" data-mp="3hb8u3keiy89w">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-325" data-mp="10qwsw6x057gb">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-326" data-mp="10o0rg8ly40n4">{t.author}</p>
                <p className="text-xs text-slate-500" data-id="element-327" data-mp="1fgcdt69uqio3">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Problem = () => {
  const painPoints = ['Llegas al gimnasio sin saber exactamente qué clase dar hoy', 'Pierdes horas buscando ejercicios, armando circuitos y pensando como adaptarlas para todo a tu grupo.', 'Terminas repitiendo entrenamientos porque no tienes suficientes sesiones listas para elegir.', 'Dejas la planificación para último momento y acabas organizando la clase la noche anterior.', 'Quieres trabajar con mayor variedad y progresión, pero planificar semanas completas lleva un tiempo que no tienes.', 'Fin de semana buscando ideas. El lunes se siente improvisado. Y el ciclo vuelve a empezar.'];
  return <Section className="bg-slate-900/40" data-id="element-328" data-mp="3ebte8rzdztx7">
      <FadeIn data-id="element-329" data-mp="3eas0uguwevcb">
        <SectionTitle data-id="element-330" data-mp="3ea8l96sq0j1g">
          Profe de <Accent data-id="element-331" data-mp="3j2tdw4zw4q3e">funcional,</Accent>
          <br data-id="element-332" data-mp="3j3une519d4j0" /> ¿esto te suena familiar?
        </SectionTitle>
      </FadeIn>

      <ul className="mx-auto mb-16 grid max-w-4xl grid-cols-1 gap-x-8 md:mb-24 md:grid-cols-2" data-id="element-333" data-mp="3o2e862448a9s">
        {painPoints.map(point => <li key={point} className="flex items-start gap-3 border-b border-white/5 py-3.5" data-id="element-334" data-mp="2qfp0bbmqf3g0">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-335" data-mp="2ve0c3rwl7o0v">
              <X size={12} className="text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-336" data-mp="30b0iy519gut1" />
            </span>
            <p className="text-[15px] leading-normal text-slate-300 md:text-base" data-id="element-337" data-mp="34bsqmtuhirn7">{point}</p>
          </li>)}
      </ul>

      <FadeIn className="mx-auto mb-12 max-w-3xl text-center md:mb-16" data-id="element-338" data-mp="jnehim6seno9">
        <h3 className="font-display text-[32px] font-black uppercase italic leading-[1.1] tracking-tight text-white sm:text-[40px] md:text-[54px]" style={{
        textWrap: 'balance'
      } as React.CSSProperties} data-id="element-339" data-mp="jpr6vkevk0bc">
          ¿Cuánto tiempo más vas a seguir <Accent data-id="element-340" data-mp="1vc3xlsphckwd">improvisando?</Accent>
        </h3>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-[15px] leading-relaxed text-slate-300 md:mt-8 md:text-lg" data-id="element-341" data-mp="1qebsfwztr2a8">
          <p data-id="element-342" data-mp="1lfquk481ouoy">
            No importa si llevas años como coach o recién estás comenzando.{' '}
            <span className="text-white" data-id="element-343" data-mp="1gfml2y5k1088">El problema no es que te falten ejercicios.</span>
          </p>
          <p data-id="element-344" data-mp="1ce14p2tta3ta">
            El problema es tener que armar cada clase desde cero. Inviertes horas
            planificando, pero cuando llega el momento, terminas ajustando cambios
            que se sienten improvisados.
          </p>
          <p data-id="element-345" data-mp="36s217h1w2eq7">Y al día siguiente, vuelves a la misma pregunta:</p>
          <p className="mx-auto inline-block rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-3 font-display text-lg font-extrabold italic leading-snug text-white md:text-2xl" data-id="element-346" data-mp="31t7j6hbqwu75">
            “¿Qué clase voy a dar mañana?”
          </p>
          <p data-id="element-347" data-mp="dcacme0y5350">
            Y semana tras semana, sigues sacrificando tu tiempo libre para resolver
            el mismo problema.
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mx-auto max-w-3xl" data-id="element-348" data-mp="meb8p7kg1j53">
        <div className="rounded-3xl border border-sky-400/40 bg-blue-600/10 px-6 py-8 text-center md:px-10 md:py-10" data-id="element-349" data-mp="mbfarj8liugn">
          <p className="font-display text-2xl font-black uppercase italic leading-[1.1] tracking-tight text-white md:text-4xl" data-id="element-350" data-mp="3qrq754ixjyvx">
            ¿Y si esta fuera la <Accent data-id="element-351" data-mp="8f1ps04usaxf">última clase</Accent>
            <br data-id="element-352" data-mp="3mqsl51hz38k" /> que preparas así?
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mt-20 text-center md:mt-28" data-id="element-353" data-mp="3knt7uegfxr6">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-amber-950" data-id="element-354" data-mp="3c1ikeclw3tpf">
          <TrophyIcon size={14} aria-hidden="true" data-id="element-355" data-mp="371mol0ncj8ky" />
          Sistema n°1 para profesores de Funcional
        </p>
        <h2 className="font-display text-4xl font-black uppercase italic leading-[1.05] tracking-tight text-white md:text-6xl" data-id="element-356" data-mp="1rbwq9k2s4lan">
          MEGAPACK Funcional <Accent data-id="element-357" data-mp="1dmbf2vv81ad6">365™</Accent>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-358" data-mp="1ijutpwvtzp5n">
          6 Tomos + 5 Bonos — 365 sesiones listas · Un año completo · Todo resuelto.
        </p>

        <div className="relative mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-slate-900 shadow-2xl shadow-black/50" data-id="element-359" data-mp="2ab0tgc7n3kue">
          <ProductVideo src={PRODUCT_VIDEO} label="Vista previa de los tomos del MEGAPACK Funcional 365" className="block w-full object-cover" data-id="element-360" data-mp="1wagc7khdhx30" />
        </div>
      </FadeIn>
    </Section>;
};